import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../views/Layout.vue'
import Login from '../views/Login.vue'
import Dashboard from '../views/Dashboard.vue'
import ModulePage from '../views/ModulePage.vue'
import TerminalPage from '../views/TerminalPage.vue'
import ProductPage from '../views/ProductPage.vue'
import OrganizationPage from '../views/OrganizationPage.vue'
import RegionPage from '../views/RegionPage.vue'
import ComplianceAssistantPage from '../views/ComplianceAssistantPage.vue'
import FeedbackPage from '../views/FeedbackPage.vue'
import DoctorSchedulePage from '../views/DoctorSchedulePage.vue'
import TrainingPage from '../views/TrainingPage.vue'
import AssessmentPage from '../views/AssessmentPage.vue'
import RolePage from '../views/RolePage.vue'
import Forbidden from '../views/Forbidden.vue'
import LogCenterPage from '../views/LogCenterPage.vue'

Vue.use(Router)

const moduleRoutes = [
  ['ai-radar','AI 预警雷达'], ['ai-policy','AI 政策情报官'],
  ['ai-insight','AI 行为洞察'],
  ['visit','拜访记录'],
  ['meeting','科室会记录'],
  ['compliance','合规校验']
].map(item => ({
  path: item[0], name: item[0], component: ModulePage,
  meta: { module: item[0], permission: item[0] + '.read', title: item[1] }
}))

export default new Router({
  mode: 'hash',
  routes: [
    { path: '/login', component: Login },
    { path: '/change-password', component: { render: h => h('div', { class: 'password-required-page' }, '请完成首次登录密码修改后进入管理后台') } },
    { path: '/403', component: Forbidden, meta: { title: '无权访问' } },
    {
      path: '/', component: Layout,
      children: [
        { path: '', redirect: 'dashboard' },
        { path: 'dashboard', name: 'dashboard', component: Dashboard, meta: { permission: 'dashboard.read', title: 'AI 工作台' } },
        { path: 'terminal', name: 'terminal', component: TerminalPage, meta: { module: 'terminal', permission: 'terminal.read', title: '终端信息库' } },
        { path: 'product', name: 'product', component: ProductPage, meta: { module: 'product', permission: 'product.read', title: '产品信息库' } },
        { path: 'org', name: 'org', component: OrganizationPage, meta: { module: 'org', permission: 'org.read', title: '人员组织库' } },
        { path: 'role', name: 'role', component: RolePage, meta: { module: 'role', permission: 'role.read', title: '角色管理' } },
        { path: 'region', name: 'region', component: RegionPage, meta: { module: 'region', permission: 'region.read', title: '省区管理' } },
        { path: 'ai-assistant', name: 'ai-assistant', component: ComplianceAssistantPage, meta: { module: 'ai-assistant', permission: 'ai-assistant.read', title: 'AI 合规助手' } },
        { path: 'feedback', name: 'feedback', component: FeedbackPage, meta: { module: 'feedback', permission: 'feedback.read', title: '客户反馈' } },
        { path: 'closeloop', name: 'closeloop', component: FeedbackPage, meta: { module: 'feedback', permission: 'feedback.write', title: '协同闭环' } },
        { path: 'plan', name: 'plan', component: DoctorSchedulePage, meta: { module: 'plan', permission: 'plan.read', title: '医生排班管理' } },
        { path: 'training', name: 'training', component: TrainingPage, meta: { module: 'training', permission: 'training.read', title: '培训学习' } },
        { path: 'kpi', name: 'kpi', component: AssessmentPage, meta: { module: 'kpi', permission: 'kpi.read', title: '考核看板' } },
        { path: 'audit', name: 'audit', component: LogCenterPage, meta: { permission: 'audit.read', title: '日志中心' } },
        ...moduleRoutes
      ]
    },
    { path: '*', redirect: '/' }
  ]
})
